/**
 * "Authentication & access" documentation section (ADR-0074).
 *
 * The hands-on operational guide to identity in Syncanix: how your team signs in
 * to the dashboard, how your own end users are authenticated, and the API keys,
 * identity-provider connections, and action-safety controls that tie them
 * together. The conceptual "why" lives in the Core-concepts `identity` page; this
 * section is the "how".
 */
import { AUTH_API_KEYS_PAGE } from './pages/auth-api-keys.page';
import { AUTH_END_USER_PAGE } from './pages/auth-end-user.page';
import { AUTH_IDENTITY_PROVIDERS_PAGE } from './pages/auth-identity-providers.page';
import { AUTH_OVERVIEW_PAGE } from './pages/auth-overview.page';
import { AUTH_SIGN_IN_PAGE } from './pages/auth-sign-in.page';
import { AUTH_STEP_UP_PAGE } from './pages/auth-step-up.page';

import type { DocSection } from './types';

export const AUTH_SECTION: DocSection = {
  id: 'auth',
  titleKey: 'docs.section.auth.title',
  pages: [
    AUTH_OVERVIEW_PAGE,
    AUTH_SIGN_IN_PAGE,
    AUTH_END_USER_PAGE,
    AUTH_IDENTITY_PROVIDERS_PAGE,
    AUTH_API_KEYS_PAGE,
    AUTH_STEP_UP_PAGE,
  ],
};
